import { render } from "./zxzb.vue?vue&type=template&id=125cb69e&scoped=true&ts=true"
import script from "./zxzb.vue?vue&type=script&lang=ts"
export * from "./zxzb.vue?vue&type=script&lang=ts"

import "./zxzb.vue?vue&type=style&index=0&id=125cb69e&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125cb69e"]])

export default __exports__